import {showErrorNotification, showInfoNotification, showSuccessNotification} from "../global/notifications";

export default function () {
    // attachSaveEvent();
    attachApproveEvent();
    attachRejectEvent();
}

const attachApproveEvent = () => {
    let $approvalButton = $('[data-role="approve"]');

    if ($approvalButton.length) {
        $approvalButton.on('click', function () {
            approveChecklist()
                .then(_ => reloadPage())
                .catch(error => showErrorNotification(error));
        })
    }
}

const approveChecklist = () => {
    return new Promise((resolve, reject) => {
        let $form = $('#certification-checklist'),
            data = $form.serialize();
        $.post('/Finance/ApproveCertificationChecklist', data, function (response) {
            if (response === true) {
                $('#Finalized').val(true);
                resolve();
            } else {
                reject(response)
            }
        });
    })
}

const attachRejectEvent = () => {
    let $approvalButton = $('[data-role="reject"]');

    if ($approvalButton.length) {
        $approvalButton.on('click', function () {
            rejectChecklist()
                .then(_ => reloadPage())
                .catch(error => showErrorNotification(error));
        })
    }
}

const rejectChecklist = () => {
    return new Promise((resolve, reject) => {
        let $form = $('#certification-checklist'),
            data = $form.serialize();
        $.post('/Finance/RejectCertificationChecklist', data, function (response) {
            if (response) {
                $('#Finalized').val(false);
                resolve();
            } else {
                reject("Unable to complete rejection")
            }
        });
    })
}

const reloadPage = () => {
    location.reload();
}